import useLabels from "../../hooks/useLabels";
import axios from "../../api/axios";

import "./styles/index.scss";
import { useEffect, useState } from "react";
import { verifyClientEmailByToken } from "../../services/utils";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { clearSession } from "../../services/SessionStorage";

const VerifyEmail = () => {
  const { setAuth } = useAuth();
  const [getLabel] = useLabels();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const confirmEmail = async () => {
      const token = new URLSearchParams(location.search).get("token");

      if (!token) {
        setStatus("invalid");
        return;
      }

      const emailConfirmed = await verifyClientEmailByToken(token, axios);
      if (emailConfirmed) {
        setStatus("success");

        setTimeout(() => {
          setAuth({});
          clearSession('authToken');
          navigate("/login")}
        , 3000)
      } else {
        setStatus("error");
      }
    };

    confirmEmail();
  }, [location.search, navigate]);

  return (
    <div className="email_verification_wrapper">
        <h1>{getLabel("userEmailVerify")}</h1>
        <div>
            {status === "loading" && <p>{getLabel("userEmailVerifyInProgress")}</p>}
            {status === "success" && <p>{getLabel("userEmailVerifyStatusOk")} 🎉</p>}
            {status === "error" && <p>{getLabel("userEmailVerifyStatusKO")} ❌</p>}
            {status === "invalid" && <p>{getLabel("userEmailVerifyInvalidLink")}</p>}
        </div>
    </div>
  );
};

export default VerifyEmail;